import React from "react";
import { FormControlLabel, Switch } from "@mui/material";
import { FeatureCollection } from "geojson";

interface GeojsonSwitchProps {
  label: string;
  geojson: FeatureCollection | null;
  setGeojson: React.Dispatch<React.SetStateAction<FeatureCollection | null>>;
  data: FeatureCollection | null;
}

const GeojsonSwitch: React.FC<GeojsonSwitchProps> = ({
  label,
  geojson,
  setGeojson,
  data,
}) => {
  return (
    <FormControlLabel
      control={
        <Switch
          checked={geojson !== null}
          onChange={() => {
            if (geojson !== null) {
              setGeojson(null);
            } else {
              setGeojson(data ?? null);
            }
          }}
        />
      }
      label={label}
    />
  );
};

export default GeojsonSwitch;
